import themes from 'themes'

/** themes.js pgaCoach palette.primary.main — navy for coach marker and info pill text */
export const PGA_COACH_NAVY = themes.pgaCoach.palette.primary.main

/** tip-well.js promo variant background — light blue callouts and info chips */
export const PGA_COACH_PROMO_BG = '#E0EAFF'

/** profile-overview error banners — negative revenue deltas */
export const PGA_COACH_ERROR_BG = '#FFEBEE'
export const PGA_COACH_ERROR_TEXT = '#C62828'
